import Button, {type ButtonProps} from '@gaia/components/Button';
import {useUser} from '@gaia/stores/user';
import gettext from '@gaia/utils/django/gettext';
import type {AuthModalContext} from '@map/contexts/AuthModalContext';
import {useCallback} from 'react';

import {MenuItemAnchor} from './MenuItemAnchor';

type ToolbarProps = ButtonProps & {
    setAuthModalState: AuthModalContext;
};

const nonModalLoginPaths = new Set(['/', '/register/']);
// cspell:disable-next-line
const nonModalLoginPathsWithRedirect = new Set(['/yearinreview/']);

function Toolbar({style, setAuthModalState, ...props}: ToolbarProps) {
    const {isAuthenticated} = useUser();

    const openAuthModal = useCallback(() => {
        const {pathname, search} = window.location;

        if (nonModalLoginPaths.has(pathname)) {
            window.location.href = `/login/${search}`;
        } else if (nonModalLoginPathsWithRedirect.has(pathname)) {
            const params = new URLSearchParams(search);
            params.set('next', pathname);
            window.location.href = `/login/?${params}`;
        } else {
            setAuthModalState({type: 'login', analyticsContext: 'header login'});
        }
    }, [setAuthModalState]);

    if (window.location.pathname === '/login/' || isAuthenticated) return null;

    return (
        <Button {...props} onClick={openAuthModal} style={style} appearance='outlined'>
            {gettext('Log In')}
        </Button>
    );
}

const HamburgerMenu = () => {
    if (useUser().isAuthenticated) return null;

    return (
        <MenuItemAnchor href={`/login/?next=${window.location.pathname}`}>
            {gettext('Log In')}
        </MenuItemAnchor>
    );
};

export const HeaderLogin = {Toolbar, HamburgerMenu};
